import dayjs from 'dayjs';
import i18n, { dayjsLocales } from '../i18n/i18n';

export const tzOffset = new Date().getTimezoneOffset();

export const formatToFrontendDate = (date?: string) => {
  if (!date) {
    return undefined;
  }
  const asDate = dayjs(date).toDate();
  return asDate;
};

export const formatRuDateString = (date?: string | null) => {
  return date ? dayjs(date).format('DD.MM.YYYY') : '';
};

export const formatRuDateTimeString = (date?: string) => {
  return date ? dayjs(date).format('DD.MM.YYYY HH:mm') : '';
};

export const formatRuTimeString = (date?: string) => {
  const formated = date ? dayjs(date).format('HH:mm') : '';
  const isZero = formated === '00:00';
  return isZero ? '' : formated;
};

export const formatToBackDateTime = (date?: Date) => {
  // чтобы корректно отображалось на фронте (получил в формате бэка, отображаю в формате бэка)
  if (!date) return undefined;
  return dayjs(date).format('YYYY-MM-DDTHH:mm:ss');
};

export const formatToBackDateTimeWithOffset = (date?: string) => {
  return dayjs(date).add(tzOffset, 'minutes').format('YYYY-MM-DDTHH:mm:ss'); // отправить на бэк с оффсетом фронта
};

export const getWeekDays = (format: string = 'dd') => {
  const daysInWeek = Array.from({ length: 7 }, (_, i) => {
    const day = dayjs()
      .locale(dayjsLocales[i18n.language])
      .isoWeekday(i + 1)
      .format(format);
    return day;
  });
  return daysInWeek;
};

export const formatDateTimeRangeFromString = (data?: string) => {
  if (!data) return undefined;
  const format = 'YYYY-MM-DDTHH:mm:ss';
  const parsed = JSON.parse(data);

  let from = parsed.from ? dayjs(parsed?.from).format(format) : undefined;
  const isFromExistAndZero = from && from.split('T')[1] === '00:00:00';
  if (isFromExistAndZero) {
    from = dayjs(from).startOf('day').format(format);
  }

  let to = parsed.to ? dayjs(parsed?.to).format(format) : undefined;
  const isToExistAndZero = to && to.split('T')[1] === '00:00:00';
  if (isToExistAndZero) {
    to = dayjs(to).add(1, 'day').add(-1, 'second').format(format);
  }

  return { from, to };
};
